module.exports = __webpack_public_path__ + "static/media/Icon 4.7d34125e.jpeg";